import styled from '@emotion/styled';
import { GlobalArea } from '@libs/templates/global-area';
import { Outlet } from 'react-router-dom';
import { hasSandboxToken } from '../../../../libs/templates/src/global-area/services';
import {
  BooksProvider,
  CompanyProvider,
  MstSettingsProvider,
  OperationControlProvider,
  ProcessingMonthProvider,
} from '../context';
import { ProcessingMonthLabel } from './ProcessingMonthLabel';
import { SandboxLabel } from './SandboxLabel';

const LabelContainer = styled.div`
  display: flex;
  gap: 5px;
`;

function ContainerWithContext() {
  return (
    <CompanyProvider>
      <ProcessingMonthProvider>
        <BooksProvider>
          <MstSettingsProvider>
            <OperationControlProvider>
              <GlobalArea homePath="/fa/main-menu">
                <LabelContainer>
                  {hasSandboxToken() && <SandboxLabel />}
                  <ProcessingMonthLabel />
                </LabelContainer>
              </GlobalArea>
              <Outlet />
            </OperationControlProvider>
          </MstSettingsProvider>
        </BooksProvider>
      </ProcessingMonthProvider>
    </CompanyProvider>
  );
}

export { ContainerWithContext };
